import { render, staticRenderFns } from "./ContractsModal.vue?vue&type=template&id=10abc244"
import script from "./ContractsModal.vue?vue&type=script&lang=js"
export * from "./ContractsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports